<template>
  <v-sheet v-if="$device.isDesktop" height="100%">
    <v-sheet class="d-flex flex-column align-center justify-center no-theme-selected" height="100%">
      <v-img :src="useAsset('/assets/img/no-result.png')" max-height="500" width="500"/>
    </v-sheet>
  </v-sheet>
  <v-sheet height="100%" width="100%" class="fill-height d-flex flex-column align-center justify-center">
    <h2 class="mb-5"> {{t('error')}}: {{ error?.message }}</h2>
    <AtomsButton :title="t('go-back')" @click="handleError"/>
  </v-sheet>
</template>
<script setup lang="ts">
import {useI18n} from "vue-i18n";

const {t} = useI18n()
const error = useError()

const handleError = () => {
  clearError({
    redirect: '/store'
  })
}
</script>

<i18n>
fr:
  error: "Une erreur est survenue"
  go-back: 'Retour à la page initiale'
en:
  create: An error occurred
  go-back: 'Go back home'
</i18n>
